// extracted by mini-css-extract-plugin
module.exports = {"mobileAppCardWrapper":"mobile-app-card_mobileAppCardWrapper_3hi","androidIcon":"mobile-app-card_androidIcon_3Nc"};